import * as React from 'react';
import { Button } from '../../../../components/button/Button';

interface IProps {
    pickupId: number;
    onDownloadPaperwork: any;
}

export const EditPickupDocuments = (props: IProps) => (
    <div className="row delivery-action-buttons divider-row">        
        <div className="col-md-12">
            <h2>Documents</h2>
            <Button 
                text="Paperwork"
                testID="pickup-document-paperwork"
                onBtnClick={ props.onDownloadPaperwork } />
        </div>
    </div>
);
